import React, {useRef} from 'react';
import {Heading1, Heading2, Heading5} from '../../typography/typography';
import Typical from 'react-typical';
import { Link as ReactRouterLink } from 'react-router-dom';

import {
    Background,
    Video,
    TextContainer,
    Container,
    Logo
} from './styles/header';


export default function Header({children, ...restProps}) {
    return <Background {...restProps}>{children}</Background>
}

Header.BackgroundVideo = function HeaderBackgroundVideo({src,...restProps}) {
    const videoRef = useRef();

    const setVideoSpeed = () => {
        videoRef.current.playbackRate = 0.8;
    }

    return (
    <Video>
        <video
        poster="/images/video.png"
        ref={videoRef}
        onCanPlay={setVideoSpeed}
        autoPlay
        loop
        muted >
            <source src={src} type="video/mp4" />
        </video>
    </Video>
    )
}

Header.Container = function HeaderContainer({children, ...restProps}) {
    return <Container {...restProps}>{children}</Container>
}

Header.TextContainer = function HeaderTextContainer({children, ...restProps}) {
    return <TextContainer>{children}</TextContainer>
}


Header.Name = function HeaderName({name,color}) {
    return <Heading1 color={color}>{name}</Heading1>
}

Header.Title = function HeaderTitle({title}) {
    return <Heading2>{title}</Heading2>
}

Header.Skills = function HeaderSkills() {
    return <Heading5><Typical
    steps={['F', 500, 'FULL STACK DEVELOPMENT', 1000,'FULL STACK DEVELOPMENT | MACHINE LEARNING',1000]}
    loop={Infinity}
    wrapper="p"
  />
  </Heading5>
}
Header.Logo = function HeaderLogo({ to, ...restProps }) {
    return <ReactRouterLink to = {to}>
                <Logo {...restProps} />
            </ReactRouterLink>
}
